type Markers = { [key: string]: any } | null | undefined;

/**
 * The markers the agreement Terms and Authorization are filled from on the
 * signing step. "Support Phone" / "Support Email" are the company contacts the
 * page footer and the E-SIGN consent show: the only other source, get-markers,
 * loads for signed-in customers only, so a customer opening the emailed link
 * read "by calling ___" in the withdrawal clause (CP-886). Using the same
 * contacts for everyone also keeps the legal text, consent and footer alike.
 */
export const buildAgreementTermsMarkers = ({
  paymentMarkers,
  generalMarkers,
  agreementMarkers,
  supportPhone,
  supportEmail,
}: {
  paymentMarkers?: Markers;
  generalMarkers?: Markers;
  agreementMarkers?: Markers;
  supportPhone?: string;
  supportEmail?: string;
}): { [key: string]: any } => ({
  ...paymentMarkers,
  ...generalMarkers,
  ...agreementMarkers,
  ...(supportPhone?.trim() ? { "Support Phone": supportPhone.trim() } : {}),
  ...(supportEmail?.trim() ? { "Support Email": supportEmail.trim() } : {}),
});
